import React from 'react';
import PropTypes from 'prop-types';
import styles from './LinkGoogleAccount.scss';

import { t } from '../../../../../../utils/InviteFriends.utils';

const LinkGoogleAccount = ({ requestContacts }) => {
  return (
    <>
      <h3 className={styles.headline}>
        {t('modal.email.gmail_request.title')}
      </h3>
      <div className={styles.content}>
        <p>{t('modal.email.gmail_request.message')}</p>
        <p>
          <em>{t('modal.email.gmail_request.disclaimer')}</em>
        </p>
      </div>
      <button type="button" onClick={requestContacts}>
        <div className={styles.gmailIcon} />
        <span className={styles.btnLabel}>
          {t('modal.email.gmail_request.button')}
        </span>
      </button>
    </>
  );
};

LinkGoogleAccount.propTypes = {
  requestContacts: PropTypes.func.isRequired
};

export default LinkGoogleAccount;
